import { MenuItem, IconButton } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import "./InterfacesChangeStatus.css";
import BaseInput from "@/components/common/baseInput";
import ClearIcon from "@/assets/icons/clear-icon.svg";

interface IInterfacesStatusSelect {
    value?: boolean | null;
    title: string;
    width?: string;
    updateStatus: (arg: boolean | null) => void;
}

const InterfacesChangeStatus: FC<IInterfacesStatusSelect> = (props: IInterfacesStatusSelect) => {
    const { t } = useTranslation();
    const selectOptions = [
        { id: null, text: t("general.All") },
        { id: true, text: t("interfaces.completed") },
        { id: false, text: t("interfaces.failed") },
    ];
    return (
        <BaseInput
            select
            label={props.title}
            size="small"
            onChange={(e: any) => {
                if (e.target.value) {
                    const option = selectOptions.find(({ text }) => text === e.target.value);
                    if (option) props.updateStatus(option.id);
                }
            }}
            value={selectOptions.find(({ id }) => id === props.value)?.text}
            sx={{ width: props.width ?? "100%" }}
            InputProps={{
                endAdornment: (
                    <IconButton
                        className="select-clear-icon"
                        sx={{
                            visibility: props.value ? "visible" : "hidden",
                        }}
                        onClick={() => props.updateStatus(null)}
                    >
                        <img src={ClearIcon} alt="Clear icon" />
                    </IconButton>
                ),
            }}
        >
            {selectOptions.map(({ text }) => (
                <MenuItem key={text} value={text}>
                    {text}
                </MenuItem>
            ))}
        </BaseInput>
    );
};

export default InterfacesChangeStatus;
